import DelinquencyModuleLayout from '@/modules/delinquency/layout/DelinquencyLayout.vue';
import { featureGuard } from '@/router/middlewares/guards';
const routes = [
  {
    path: 'dashboard',
    name: 'delinquency-dashboard',
    meta: {
      requiredModuleAccess: 'Delinquency-Pro'
    },
    component: () => import('@/modules/delinquency/views/Dashboard.vue')
  },
  {
    path: 'case-activity-summary-report-hub',
    name: 'case-activity-summary-report-hub', 
    meta: {
      requiredPrivileges: ["Delinquency Pool Report"]
    },
    component: () => import('@/modules/delinquency/views/CaseActivityReportHub.vue')
  },
  {
    path: 'case-activity-summary-report',
    name: 'case-activity-summary-report',
     meta: {
      requiredPrivileges: ["Delinquency Pool Report"]
    },
    component: () => import('@/modules/delinquency/views/CaseActivitySummaryReport.vue')
  },
  {
    path: 'case-manager-activity-report',
    name: 'case-manager-activity-report',
     meta: {
      requiredPrivileges: ["Delinquency Pool Report"]
    },
    component: () => import('@/modules/delinquency/views/CaseManagerActivityReport.vue')
  },
  {
    path: 'dca-activity-summary',
    name: 'dca-activity-summary',
     meta: {
      requiredPrivileges: ["Delinquency Pool Report"]
    },
    component: () => import('@/modules/delinquency/views/DCAActivitySummary.vue')
  },
  {
    path: 'delinquency-pool',
    name: 'delinquency-pool',
    meta: {
      requiredPrivileges: ['View Delinquency Pool']
    },
    component: () => import('@/modules/delinquency/views/DelinquencyPool.vue')
  },
  {
    path: 'my-foreclosure-loans',
    name: 'my-foreclosure-loans',
    meta: {
      requiredPrivileges: ['Process Foreclosure Loan', 'Manage Collateral']
    },
    component: () =>
      import(
        '@/modules/delinquency/views/my-workload/AssignedForeclosureCases.vue'
      )
  },
  {
    path: 'my-assigned-actions',
    name: 'my-assigned-actions',
    meta: {
      requiredPrivileges: ['Process Assigned Actions']
    },
    component: () =>
      import('@/modules/delinquency/views/my-workload/AssignedActions.vue')
  },
  {
    path: 'my-assigned-cases',
    name: 'my-assigned-cases',
    meta: {
      requiredPrivileges: ['Process Delinquency Cases']
    },
    component: () =>
      import('@/modules/delinquency/views/my-workload/AssignedCases.vue')
  },
  {
    path: 'loan-insertion',
    name: 'loan-insertion',
    meta: {
      requiredPrivileges: ['Process Delinquency Cases']
    },
    component: () =>
      import('@/modules/delinquency/views/ManualLoanInsertion.vue')
  },
  {
    path: 'manage-loans',
    name: 'delinquency-manage-loans',
    meta: {
      requiredPrivileges: ['Manage Loans'] 
    },
    component: () =>
      import('@/modules/loanpro/components/loan-pro/loan-services/ManageLoans.vue')
  },
  {
    path: 'my-escalated-cases',
    name: 'my-escalated-cases',
    beforeEnter: featureGuard('loanEscalationManagement'),
    meta: {
      requiredPrivileges: ['Process Escalated Cases']
    },
    component: () =>
      import('@/modules/delinquency/views/my-workload/EscalatedCases.vue')
  },
  {
    path: 'my-approved-loans',
    name: 'my-approved-loans',
    component: () =>
      import('@/modules/delinquency/views/my-workload/ApprovedLoans.vue')
  },
  {
    path: 'my-created-loans',
    name: 'my-created-loans',
    component: () =>
      import('@/modules/delinquency/views/my-workload/CreatedLoans.vue')
  },
  {
    path: 'external-participants',
    name: 'external-participants',
    beforeEnter: featureGuard('externalCollections'),
    meta: {
      requiredPrivileges: ['Manage External Participant']
    },
    component: () =>
      import('@/modules/delinquency/views/ExternalParticipants.vue')
  },
  {
    path: 'external-participant-receipts',
    name: 'external-participant-receipts',
    beforeEnter: featureGuard('externalCollections'),
    meta: {
      requiredPrivileges: ['Manage External Participant']
    },
    component: () =>
      import('@/modules/delinquency/views/ExternalParticipantReceipts.vue')
  },
  {
    path: 'external-collections-management',
    name: 'external-collections-management',
    component: () =>
      import('@/modules/delinquency/views/ExternalCollectionsManagement.vue')
  },
  {
    path: 'foreclosure-processing',
    name: 'foreclosure-processing',
    beforeEnter: featureGuard('collateralManager'),
    meta: {
      requiredPrivileges: ['Process Foreclosure Loan', 'Manage Collateral']
    },
    component: () =>
      import(
        '@/modules/delinquency/views/foreclosure-management/ForeclosureLoans.vue'
      )
  },
  {
    path: 'foreclosure-loans/:id/confirmation',
    name: 'foreclosure-loans-id-confirmation',
    meta: {
      requiredPrivileges: ['Process Foreclosure Loan']
    },
    component: () =>
      import(
        '@/modules/delinquency/views/foreclosure-management/ForeclosureLoanConfirmation.vue'
      )
  },
  {
    path: 'foreclosure-loans/:id/asset-management',
    name: 'foreclosure-loans-id-asset-management',
    meta: {
      requiredPrivileges: ['Process Foreclosure Loan']
    },
    component: () =>
      import(
        '@/modules/delinquency/views/foreclosure-management/ForeclosureLoanAssetManagement.vue'
      )
  },
  {
    path: 'foreclosure-loans/:id/foreclosure-legal-processing',
    name: 'foreclosure-loans-id-foreclosure-legal-processing',
    meta: {
      requiredPrivileges: ['Process Foreclosure Loan']
    },
    component: () =>
      import(
        '@/modules/delinquency/views/foreclosure-management/ForeclosureLegalProcessing.vue'
      )
  },
  {
    path: 'foreclosure-loans/:id/foreclosure-asset-registration-sale',
    name: 'foreclosure-loans-id-foreclosure-assets-registration-sale',
    meta: {
      requiredPrivileges: ['Process Foreclosure Loan']
    },
    component: () =>
      import(
        '@/modules/delinquency/views/foreclosure-management/ForeclosureAssetRegistrationSale.vue'
      )
  },
  {
    path: 'foreclosure-loans/:id/foreclosure-case-closure',
    name: 'foreclosure-loans-id-foreclosure-case-closure',
    meta: {
      requiredPrivileges: ['Process Foreclosure Loan']
    },
    component: () =>
      import(
        '@/modules/delinquency/views/foreclosure-management/ForeclosureCaseClosure.vue'
      )
  },
  {
    path: 'foreclosed-asset-register',
    name: 'foreclosed-asset-register',
    meta: {
      requiredPrivileges: ['Process Foreclosure Loan']
    },
    component: () =>
      import(
        '@/modules/delinquency/views/foreclosure-management/ForeclosedAssetRegister.vue'
      )
  },
  {
    path: 'foreclosure-loan/:id/summary',
    name: 'foreclosure-loan-summary',
    meta: {
      requiredPrivileges: ['Process Foreclosure Loan']
    },
    component: () =>
      import(
        '@/modules/delinquency/components/foreclosure-loans/ForeclosureLoanSummary.vue'
      )
  },
  {
    path: 'my-charge-off-cases',
    name: 'my-charge-off-cases',
    meta: {
      requiredPrivileges: ['Process Charge Off Loan']
    },
    component: () =>
      import(
        '@/modules/delinquency/views/my-workload/AssignedChargedOffCases.vue'
      )
  },
  {
    path: 'pending-charge-off-cases',
    name: 'pending-charge-off-cases',
     meta: {
      requiredPrivileges:  ['Process Charge Off Loan', 'Approve Charge Off Process']
    },
    component: () =>
      import(
        '@/modules/delinquency/views/my-workload/PendingChargedOffCases.vue'
      )
  },
  {
    path: 'charged-off-loan-processing',
    name: 'charged-off-loan-processing',
    meta: {
      requiredPrivileges: ['Process Charge Off Loan', 'Manage Collateral']
    },
    component: () =>
      import(
        '@/modules/delinquency/views/charged-off-loan-management/ChargeOffLoans.vue'
      )
  },
  {
    path: 'charge-off-loans/:id/management',
    name: 'charge-off-loans-id-management',
    meta: {
      requiredPrivileges: ['Process Charge Off Loan', 'Manage Collateral']
    },
    component: () =>
      import(
        '@/modules/delinquency/views/charged-off-loan-management/ChargedOffLoansManagement.vue'
      )
  },
  {
    path: 'charge-off-loans/:id/summary',
    name: 'charge-off-loans-id-charge-off-loan-case-summary',
    meta: {
      requiredPrivileges: ['Process Charge Off Loan', 'Manage Collateral']
    },
    component: () =>
      import(
        '@/modules/delinquency/components/charge-off-loans/ChargedOffLoanSummary.vue'
      )
  },
  {
    path: 'collateral-and-owner-registry',
    name: 'collateral-and-owner-registry',
    beforeEnter: featureGuard('collateralManager'),
    meta: {
      requiredPrivileges: ['Manage Collateral']
    },
    component: () =>
      import('@/modules/shared/components/CollateralManagement.vue')
  },
  {
    path: 'charge-off-loans',
    name: 'charge-off-loans-module',
    meta: {
      requiredPrivileges: ['Process Charge Off Loan', 'Manage Collateral']
    },
    component: () => import('@/modules/delinquency/views/ChargeOffLoans.vue')
  },
  {
    path: 'early-warning-watch-list',
    name: 'early-warning-watch-lis',
    beforeEnter: featureGuard('earlyWarningModule'),
    component: () =>
      import('@/modules/delinquency/views/EarlyWarningWatchList.vue')
  },
  {
    path: 'case-management-history',
    name: 'case-management-history',
    meta: {
      requiredPrivileges: ["Delinquency Pool Report"]
    },
    component: () =>
      import('@/modules/delinquency/views/CaseManagementHistory.vue')
  },
  {
    path: 'comparison-spool-report',
    name: 'comparison-spool-report',
    meta: {
      requiredPrivileges: ["Delinquency Pool Report"]
    },
    component: () =>
      import('@/modules/delinquency/views/ComparisonOptionsReport.vue')
  },
  {
    path: 'delinquency-management-targets',
    name: 'delinquency-management-targets',
    component: () =>
      import('@/modules/delinquency/views/DelinquencyManagementTargets.vue')
  },
  {
    path: 'case-view/:id',
    name: 'case-view',
    meta: {
      requiredPrivileges: ['View Delinquency Case File']
    },
    component: () => import('@/modules/delinquency/views/CaseView.vue')
  },
  {
    path: 'collateral-risk-scoring',
    name: 'collateral-risk-scoring',
    beforeEnter: featureGuard('collateralManager'),
    meta: {
     requiredPrivileges:  ['Manage Collateral']
    },
    component: () =>
      import('@/modules/delinquency/views/CollateralRiskScoring.vue')
  },
  {
    path: 'report-matrix',
    name: 'report-matrix',
    meta: {
      requiredPrivileges: ["Delinquency Pool Report"]
    },
    component: () => import('@/modules/delinquency/views/ReportMatrix.vue')
  },
  {
    path: 'delinquency-control-target',
    name: 'delinquency-control-target',
    meta: {
      requiredPrivileges: ["Delinquency Pool Report"]
    },
    component: () =>
      import('@/modules/delinquency/views/DelinquencyControlTarget.vue')
  },
  {
    path: 'early-warning-watchlist',
    name: 'early-warning-watchlist',
    component: () =>
      import('@/modules/delinquency/views/EarlyWarningWatchList.vue')
  },
  // {
  //   path: 'notification-history',
  //   name: 'notification-management',
  //   component: () =>
  //     import(
  //       '@/modules/shared/components/notifications/NotificationHistory.vue'
  //     )
  // },
  {
    path: '/report/:id',
    name: 'SpoolingReportDetail', 
    meta: {
      requiredPrivileges: ["Delinquency Pool Report"]
    },
    component: () =>
      import('@/modules/reports/components/SpoolingReportDetail.vue')
  }
];

export default {
  path: 'delinquency-management',
  name: 'delinquency-management-module',
  component: DelinquencyModuleLayout,
  redirect: {
    name: 'delinquency-dashboard'
  },
  meta: {
    requiresAuth: true,
    requiresModuleAccess: true,
    app: 'Delinquency-Pro'
  },
  children: [...routes]
};
